module.exports = __webpack_public_path__ + "static/media/user_account.267db448.svg";